import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

export default function JupasSurveyCandidateConfirmModal({ open, onConfirm, onExit }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[250] flex items-center justify-center bg-black/55 px-4 py-8" role="presentation" onClick={onExit}>
      <section
        className="w-full max-w-lg rounded-2xl border border-edge bg-surface-elevated p-6 text-left shadow-2xl sm:p-7"
        role="dialog"
        aria-modal="true"
        aria-labelledby="jupas-survey-candidate-title"
        aria-describedby="jupas-survey-candidate-description"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="jupas-survey-candidate-title" className="text-xl font-bold text-ink sm:text-2xl">
          {t('jupasSurvey.home.candidateConfirm.title')}
        </h2>
        <p id="jupas-survey-candidate-description" className="mt-3 text-sm leading-6 text-ink-muted">
          {t('jupasSurvey.home.candidateConfirm.body')}
        </p>

        <div className="mt-6 grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onConfirm}
            className="rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('jupasSurvey.home.candidateConfirm.confirm')}
          </button>
          <button
            type="button"
            onClick={onExit}
            className="rounded-lg border border-edge-strong px-4 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-surface-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('jupasSurvey.home.candidateConfirm.exit')}
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
